import script from "./Stats.vue?vue&type=script&setup=true&lang=ts"
export * from "./Stats.vue?vue&type=script&setup=true&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=01b1dc6c&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b1dc6c"]])

export default __exports__